//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : AndrÃ© Silva : https://github.com/askpt

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'EanÃ¡ir',
            'Feabhra',
            'MÃ¡rta',
            'AibreÃ¡n',
            'Bealtaine',
            'Meitheamh',
            'IÃºil',
            'LÃºnasa',
            'MeÃ¡n FÃ³mhair',
            'Deireadh FÃ³mhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'MÃ¡rt',
            'Aib',
            'Beal',
            'Meith',
            'IÃºil',
            'LÃºn',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'DÃ© Domhnaigh',
            'DÃ© Luain',
            'DÃ© MÃ¡irt',
            'DÃ© CÃ©adaoin',
            'DÃ©ardaoin',
            'DÃ© hAoine',
            'DÃ© Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'MÃ¡irt', 'CÃ©ad', 'DÃ©ar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'MÃ¡', 'CÃ©', 'DÃ©', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[AmÃ¡rach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[InnÃ© ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s Ã³ shin',
            s: 'cÃºpla soicind',
            ss: '%d soicind',
            m: 'nÃ³imÃ©ad',
            mm: '%d nÃ³imÃ©ad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lÃ¡',
            dd: '%d lÃ¡',
            M: 'mÃ­',
            MM: '%d mÃ­onna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));
